<template>
    <div class="container-fluid ">
        <div class="row">
            <div class="col-md-12">
                <div class="calendar-container">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="text-center mt-3">📅 Calendario</h4>
                            
                            <p class="ps-5 text-muted text-start">1.- Selecciona una fecha para agendar una cita.</p>
                            <vue-event-calendar :title="calendarioTitulo" :events="eventos" :locale="'es'"
                                :editable="true" @day-changed="seleccionarFecha" @event-click="verEvento" />


                                <p class="text-muted text-start ps-5">2.- Busca un paciente por nombre para agendar una cita
                            </p>


                                <search-talent class="ps-5 pe-5" :main-id="personal_medico_id" @notify="notify"
                                @select="handlePacienteSelected" />
                                <a class="ps-5 smallText text-center" @click="mostrarDialogoHorarios = true" href="#">🕒 Ver horarios</a>
                                <a class=" smallText text-center ms-3" @click="mostrarCrearPaciente" href="#">👤 Crear Paciente</a>

                            
                            
                            <p class="text-center mt-3"><strong class="fw-bold">{{fechaMarcador}}</strong></p>
                            <p class="text-center mt-3" v-if="!fechaMarcador"><strong class="fw-bold">{{`⏰ ${moment().format('dddd, D [de] MMMM [de] YYYY')}`}}</strong></p>


                            <div class="row" v-if="consultasHoy.length > 0">
                                <div v-for="(evento, index) in consultasHoy" :key="index" class="col-md-3 mb-3 ">
                                    <div class="card h-100">
                                        <div class="card-body">
                                            <p class="card-title">📅 <strong>{{ moment(evento.inicio_cita).format('dddd, D [de] MMMM [de] YYYY, h:mm A') }} hasta las {{ moment(evento.fin_cita).format('h:mm A') }}</strong> <br>
                                            
                                                <span v-if="evento.estatus_cita === 'confirmada'" class="badge bg-success">Confirmada</span>
                                                <span v-else-if="evento.estatus_cita === 'cancelada'" class="badge bg-danger">Cancelada</span>
                                                <span v-else-if="evento.estatus_cita === 'no asistió'" class="badge bg-warning text-dark">No asistió</span>
                                                <span v-else-if="evento.estatus_cita === 'agendada'" class="badge bg-info text-dark">Agendada</span>
                                                <span v-else class="badge bg-secondary">No aplica</span>
                                            </p>
                                            <p class="smallText">
                                                <strong class="fw-bold">Paciente:</strong> {{ evento.nombre_paciente || 'No aplica' }}<br>
                                                <strong class="fw-bold">Motivo:</strong> {{ evento.motivo || 'No aplica' }}<br>
                                                <strong class="fw-bold">Tipo de consulta:</strong> {{ evento.tipo_consulta || 'No aplica' }} <br>
                                                <strong class="fw-bold">Origen:</strong> {{ evento.origen || 'No aplica' }} <br>
                                            </p>
                                            <p class="smallText" v-if="evento.estatus_cita === 'cancelada'">
                                                <strong class="fw-bold">Motivo de cancelación:</strong> {{ evento.motivo_cancelacion || 'No aplica' }}<br>
                                                <strong class="fw-bold">Fecha de cancelación:</strong> {{ moment(evento.fecha_cancelacion).format('dddd, D [de] MMMM [de] YYYY, h:mm A') || 'No aplica' }}
                                            </p>
                                            <p class="smallText" v-if="evento.estatus_cita === 'confirmada'">
                                                <strong class="fw-bold">Fecha de confirmación:</strong> {{ moment(evento.fecha_confirmacion).format('dddd, D [de] MMMM [de] YYYY, h:mm A') || 'No aplica' }}
                                            </p>
                                            <vs-button v-if="evento.estatus_cita !== 'no asistió' && evento.estatus_cita !== 'cancelada'" 
                                                @click="cambiarEstatus(evento)" color="rgb(59,222,200)" gradient block>
                                                Cambiar estatus
                                            </vs-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 mb-3" v-if="fechaMarcador">
                                    <div class="card h-100" style="border-style: dashed;border-width: medium;">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-center align-items-center h-100">
                                                <a class="smallText text-center" @click="solicitarCita" href="#"><strong>📝 Crear cita</strong></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="text-muted text-center mt-3">No tienes eventos en la fecha seleccionada</p>
                                <div class="row">
                                    <div class="col-md-3 mb-3 ">
                                        <div class="card h-100" style="border-style: dashed;border-width: medium;">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <a class="smallText text-center" @click="solicitarCita" href="#"><strong>📝 Crear cita</strong></a>
                                                </div>
                                                <br>
                                                <br>
                                                <br>
                                                <br>
                        
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                         
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <vs-dialog v-model="mostrarDialogoHorarios" title="Horarios Disponibles">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-center mt-3"><strong class="fw-bold">⏰ Horarios disponibles
                            </strong></p>
                        <div class="table-responsive">
                            <vs-table class="custom-table">
                                <template #thead>
                                    <vs-tr>
                                        <vs-th>Día</vs-th>
                                        <vs-th>Hora Inicio</vs-th>
                                        <vs-th>Hora Fin</vs-th>
                                        <vs-th>Estatus</vs-th>
                                    </vs-tr>
                                </template>
                                <template #tbody>
                                    <vs-tr :key="horario.id" v-for="horario in horariosDisponibles"
                                        :data="horario">
                                        <vs-td>{{ horario.dia_semana }}</vs-td>
                                        <vs-td>{{ formatTime(horario.hora_inicio) }}</vs-td>
                                        <vs-td>{{ formatTime(horario.hora_fin) }}</vs-td>
                                        <vs-td>{{ horario.estatus }}</vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>

        <vs-dialog v-model="mostrarFormulario" title="Nueva Cita">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    📆 Agendar nueva consulta
                </h4>
            </template>
            <div class="container">
                <div class="row" v-if="userStats !== 1">
                    <div class="col-md-12">
                        <p><strong>Paciente seleccionado:</strong></p>
                        <ul class="list-unstyled smallText">
                            <li><strong>Nombre:</strong> {{ pacienteSeleccionado?.nombre || 'No disponible' }}</li>
                            <li><strong>Género:</strong> {{ pacienteSeleccionado?.genero || 'No disponible' }}</li>
                            <li><strong>Fecha de nacimiento:</strong> {{
                                formatFecha(pacienteSeleccionado?.fecha_nacimiento) ||
                                'No disponible' }}</li>
                            <li><strong>Teléfono:</strong> {{ pacienteSeleccionado?.telefono || 'No disponible' }}</li>
                            <li><strong>Email:</strong> {{ pacienteSeleccionado?.email || 'No disponible' }}</li>
                            <li><strong>Dirección:</strong> {{ pacienteSeleccionado?.direccion || 'No disponible' }}
                            </li>

                        </ul>

                        <p class="text-center"><strong class="fw-bold">Has seleccionado el día: {{ form.fecha ?
                                formatFecha(form.fecha) : 'No disponible' }}</strong></p>
                    </div>
                    <div class="col-md-12 mb-3">
                        <p>Motivo de la consulta:
                            <input id="motivo" type="text" class="form-control" v-model="form.motivo"
                                placeholder="Motivo de la consulta" />
                        </p>
                    </div>
                    <div class="col-md-6 mb-3">
                        <p>Hora de inicio:
                            <input id="horaInicio" type="time" class="form-control" v-model="form.horaInicio" />
                        </p>
                    </div>
                    <div class="col-md-6 mb-3">
                        <p>Hora de fin:
                            <input id="horaFin" type="time" class="form-control" v-model="form.horaFin" />
                        </p>
                    </div>
                    <div class="col-md-6 mb-3">
                        <p>Tipo de consulta:
                            <select id="tipoConsulta" class="form-control" v-model="form.tipoConsulta">
                                <option value="en consultorio">En consultorio</option>
                                <option value="a domicilio">A domicilio</option>
                                <option value="a hospital">A hospital</option>
                                <option value="virtual">Virtual</option>
                                <option value="otra">Otra</option>
                            </select>
                        </p>
                    </div>
                    <div class="col-md-6 mb-3">
                        <p>Origen:
                            <select id="origen" class="form-control" v-model="form.origen">
                                <option value="recomendacion">Recomendación</option>
                                <option value="whatsapp">WhatsApp</option>
                                <option value="sitio web">Sitio web</option>
                                <option value="llamada telefónica">Llamada telefónica</option>
                                <option value="email">Email</option>
                                <option value="redes sociales">Redes sociales</option>
                                <option value="otro">Otro</option>
                                <option value="seguimiento">Seguimiento</option>
                            </select>
                        </p>
                    </div>
                    <div class="col-md-12 text-center">
                        <vs-button @click="guardarCita" color="rgb(59,222,200)" gradient block>
                            💾 Guardar Cita
                        </vs-button>
                        <a class="smallText text-center" @click="mostrarFormulario = false" href="#">Cancelar</a>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="alert alert-warning text-center">
                            ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                            <router-link to="/paquetes">Renovar aquí</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>

        <vs-dialog v-model="mostrarDialogoEstatus" title="Cambiar Estatus de la Consulta">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    Cambiar estatus de la consulta
                </h4>
            </template>
            <div class="container">
                <div class="row" v-if="userStats !== 1">
                    <div class="col-md-12 mb-3">
                        <p>Estatus de la consulta:
                            <select id="estatusCita" class="form-control" v-model="formEstatus.estatus_cita">
                                <option value="confirmada">Confirmada</option>
                                <option value="cancelada">Cancelada</option>
                                <option value="no asistió">No asistió</option>
                            </select>
                        </p>
                    </div>
                    <div class="col-md-12 mb-3" v-if="formEstatus.estatus_cita === 'cancelada'">
                        <p>Motivo de cancelación:
                            <input id="motivoCancelacion" type="text" class="form-control" v-model="formEstatus.motivo_cancelacion"
                                placeholder="Motivo de cancelación" />
                        </p>
                    </div>
                    <div class="col-md-12 text-center">
                        <vs-button @click="actualizarEstatus" color="rgb(59,222,200)" gradient block>
                            💾 Guardar Cambios
                        </vs-button>
                        <a class="smallText text-center" @click="mostrarDialogoEstatus = false" href="#">Cancelar</a>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12" >
                           <div class="alert alert-warning text-center">
                                ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                                <router-link to="/paquetes">Renovar aquí</router-link>
                            </div>
                    </div>
                </div>
            </div>
        </vs-dialog>
        
        <vs-dialog prevent-close v-model="showPacienteDialog" title="Crear Paciente">
            <template #header>
                <h4 class="not-margin mt-3 text-center">
                    👤 Crear Paciente
                </h4>
            </template>
            <!-- En Pacientes.vue o similar -->
            <div v-if="userStats !== 1">
                <CrearPaciente :personal_medico_id="personal_medico_id" @pacienteCreado="handlePacienteCreado" />
            </div>
            <div v-else>
                <div class="alert alert-warning text-center">
                    ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                    <router-link to="/paquetes">Renovar aquí</router-link>
                </div>
            </div>
        </vs-dialog>



    </div>
</template>

<script>
    import VueEventCalendar from 'vue-event-calendar';
    import 'vue-event-calendar/dist/style.css';
    import Vue from 'vue';
    import SearchTalent from './SearchTalent.vue';
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api; // Add API constant for future use
    import moment from 'moment';
    moment.locale('es'); // Configura moment.js para usar el idioma español
    import CrearPaciente from './CrearPaciente.vue'; // Importa el componente CrearPaciente

    Vue.use(VueEventCalendar, { locale: 'es' });

    export default {
        name: "Calendario",
        components: {
            SearchTalent,
            CrearPaciente
        },
        props: {
            personal_medico_id: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                showPacienteDialog: false,
                fechaSeleccionada: null,
                fechaMarcador: null,
                eventos: [
                    {
                        date: this.getLocalDate(),
                        title: 'Consulta General'
                    },
                    {
                        date: this.getLocalDate(),
                        title: 'Revisión Dental'
                    }
                ],
                consultasHoy: [], // Almacena las consultas de hoy
                mostrarFormulario: false,
                form: {
                    fecha: '', // Fecha seleccionada
                    horaInicio: '08:00', // Hora de inicio por defecto
                    horaFin: '09:00', // Hora de fin por defecto
                    motivo: '',
                    tipoConsulta: 'en consultorio', // Valor por defecto
                    origen: 'recomendacion' // Valor por defecto
                },
                pacienteSeleccionado: null, // Almacena el paciente seleccionado
                horariosDisponibles: [], // Almacena los horarios disponibles
                mostrarDialogoHorarios: false, // Controla la visibilidad del diálogo de horarios
                mostrarDialogoEstatus: false,
                consultaSeleccionada: null,
                formEstatus: {
                    estatus_cita: 'confirmada',
                    motivo_cancelacion: ''
                },
                userStats:null
            };
        },
        computed: {
            calendarioTitulo() {
                const fechaActual = new Date();
                const meses = [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];
                const mes = meses[fechaActual.getMonth()];
                const anio = fechaActual.getFullYear();
                return `${mes} ${anio}`;
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.eliminarEventsWrapper();
            });
            setTimeout(() => {
                this.cargarHorariosDisponibles(); // Llama al método para cargar los horarios
            }, 33);
            this.cargarEventos(); // Llama al método para cargar los eventos
            this.cargarConsultasHoy(); // Llama al método para cargar las consultas de hoy
            
            setTimeout(() => {
                this.userStats = this.getUserStatus();
                console.log('User Status::::::::::::::::::::::::::::', this.getUserStatus());
            }, 500);

        },
        watch: {
            mostrarFormulario(newValue) {
                if (!newValue) {
                    this.pacienteSeleccionado = null; // Limpia el paciente seleccionado
                    this.form = {
                        fecha: '',
                        horaInicio: '08:00',
                        horaFin: '09:00',
                        motivo: '',
                        tipoConsulta: 'en consultorio',
                        origen: 'recomendacion'
                    };
                }
            }
        },
        methods: {
            handlePacienteCreado() {
                this.showPacienteDialog = false; // Cierra el diálogo de crear paciente
                this.notify('success', 'Paciente creado correctamente. Ahora puedes agregar una cita.');
            },  
            mostrarCrearPaciente(){
                this.showPacienteDialog = true; // Muestra el diálogo de crear paciente
            },
            async handlePacienteSelected(paciente) {
                console.log('Paciente seleccionado:', paciente);
                this.pacienteSeleccionado = paciente; // Almacena el paciente seleccionado
                this.notify('success', 'Paciente seleccionado correctamente. Ahora puedes agrenadar una cita.');
            },
            getLocalDate() {
                const now = new Date();
                now.setMinutes(now.getMinutes() - now.getTimezoneOffset()); // Ajusta la fecha a la zona horaria local
                return now.toISOString().split('T')[0]; // Devuelve solo la parte de la fecha (YYYY-MM-DD)
            },
            async seleccionarFecha(day) {
                const fechaSeleccionada = new Date(day.date);
                this.fechaSeleccionada = day; // Almacena la fecha seleccionada
                const fechaActual = new Date();
                fechaActual.setHours(0, 0, 0, 0); // Establece la hora a 00:00:00 para comparar solo la fecha

                console.log('Fecha seleccionada:', fechaSeleccionada);
                const fechaFormateada = moment(fechaSeleccionada).format('YYYY-MM-DD');
                console.log('Fecha formateada:', fechaFormateada);
                this.fechaMarcador = `⏰ ${ moment(fechaFormateada).format('dddd, D [de] MMMM [de] YYYY') }`; 

                // if (fechaSeleccionada < fechaActual) {
                //     this.notify('error', 'No puedes seleccionar una fecha anterior a hoy.');
                //     return;
                // }

                // if (!this.pacienteSeleccionado) {
                //     this.notify('error', 'Primero debes seleccionar un paciente.');
                //     return;
                // }

                // this.form.fecha = day.date; // Asigna la fecha seleccionada al formulario
                // this.mostrarFormulario = true; // Muestra el formulario

                // Llamar al endpoint para obtener consultas por fecha

                this.citasPorFecha(fechaFormateada); // Llama al método para cargar las citas por fecha
               
            },
            async citasPorFecha(fechaFormateada){
                try {
                    const response = await axios.get(`${API}/listar-consultas-por-fecha`, {
                        params: {
                            personal_medico_id: this.personal_medico_id,
                            fecha_consulta: fechaFormateada,
                        },
                    });

                    if (response.data.status === 'success') {
                        this.consultasHoy = response.data.data; // Asigna la respuesta a consultasHoy
                        console.log('Consultas para la fecha seleccionada:', this.consultasHoy);
                    } else {
                        console.error('Error al cargar consultas por fecha:', response.data.message);
                        this.consultasHoy = []; // Limpia consultasHoy en caso de error
                    }
                } catch (error) {
                    console.error('Error al consumir el endpoint de consultas por fecha:', error);
                    this.consultasHoy = []; // Limpia consultasHoy en caso de error
                }
            },
            async solicitarCita() {
                const fechaSeleccionada = new Date(this.fechaSeleccionada.date);
                const fechaActual = new Date();
                fechaActual.setHours(0, 0, 0, 0); 

                if (fechaSeleccionada < fechaActual) {
                    this.notify('error', 'No puedes seleccionar una fecha anterior a hoy.');
                    return;
                }

                if (!this.pacienteSeleccionado) {
                    this.notify('error', 'Primero debes seleccionar un paciente.');
                    return;
                }

                this.form.fecha = this.fechaSeleccionada.date; // Asigna la fecha seleccionada al formulario
                this.mostrarFormulario = true; // Muestra el formulario



            },
            verEvento(event) {
                console.log('Evento seleccionado:', event);
            },
            async guardarCita() {
                try {
                    // Validar que todos los campos estén llenos
                    if (!this.vEmpty(this.form.fecha, 'Fecha') ||
                        !this.vEmpty(this.form.horaInicio, 'Hora de inicio') ||
                        !this.vEmpty(this.form.horaFin, 'Hora de fin') ||
                        !this.vEmpty(this.form.motivo, 'Motivo de la consulta') ||
                        !this.vEmpty(this.form.tipoConsulta, 'Tipo de consulta') ||
                        !this.vEmpty(this.form.origen, 'Origen')) {
                        return;
                    }

                    // Validar que la hora de inicio no sea mayor a la hora de fin
                    if (this.form.horaInicio >= this.form.horaFin) {
                        this.notify('error', 'La hora de inicio no puede ser mayor o igual a la hora de fin.');
                        return;
                    }

                    const inicioCita = `${this.form.horaInicio}:00`;
                    const finCita = `${this.form.horaFin}:00`;

                    const nuevaCita = {
                        paciente_id: this.pacienteSeleccionado?.id,
                        personal_medico_id: this.personal_medico_id,
                        motivo: this.form.motivo,
                        tipo_consulta: this.form.tipoConsulta,
                        inicio_cita: inicioCita,
                        fin_cita: finCita,
                        estatus_cita: 'agendada',
                        origen: this.form.origen,
                        fecha_seleccionada: this.form.fecha,
                    };

                    const response = await axios.post(`${API}/agendar-cita`, nuevaCita);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Cita agendada exitosamente.');

                        await this.callAudit(this.personal_medico_id,"CREAR","consultas",this.personal_medico_id,"Se agenda cita para el paciente: "+this.pacienteSeleccionado.nombre+" con fecha: "+this.form.fecha+" y hora de inicio: "+this.form.horaInicio+" y hora de fin: "+this.form.horaFin);
                        console.log('push', this.form.fecha, this.form.motivo, this.form.horaInicio, this.form.horaFin);
                        this.eventos.push({
                            date: this.form.fecha,
                            title: this.form.motivo,
                            horaInicio: this.form.horaInicio,
                            horaFin: this.form.horaFin
                        });
                        this.mostrarFormulario = false;
                        this.citasPorFecha(moment(this.form.fecha).format('YYYY-MM-DD')); // Actualiza las citas por fecha
                    } else {
                        this.notify('error', response.data.message || 'Error al agendar la cita.');
                    }
                } catch (error) {
                    console.error('Error al agendar la cita:', error.response?.data?.message || error.message);
                    this.notify('error', error.response?.data?.message || error.message);
                }
            },
            async cambiarEstatus(evento) {
            console.log('Evento seleccionado para cambiar estatus:', evento);   
                this.consultaSeleccionada = evento; // Almacena la consulta seleccionada
                this.formEstatus = {
                    estatus_cita: 'confirmada',
                    motivo_cancelacion: ''
                };
                this.mostrarDialogoEstatus = true; // Muestra el diálogo
            },
            async actualizarEstatus() {
                try {
                    // Validar que el estatus esté seleccionado
                    if (!this.vEmpty(this.formEstatus.estatus_cita, 'Estatus de la consulta')) {
                        return;
                    }

                    // Validar motivo de cancelación si el estatus es "cancelada"
                    if (this.formEstatus.estatus_cita === 'cancelada' &&
                        !this.vEmpty(this.formEstatus.motivo_cancelacion, 'Motivo de cancelación')) {
                        return;
                    }

                    const payload = {
                        estatus_cita: this.formEstatus.estatus_cita,
                    };

                    if (this.formEstatus.estatus_cita === 'cancelada') {
                        payload.motivo_cancelacion = this.formEstatus.motivo_cancelacion;
                    }

                    const response = await axios.put(`${API}/actualizar-consulta/${this.consultaSeleccionada.id}`, payload);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Estatus de la consulta actualizado exitosamente.');

                        await this.callAudit(this.personal_medico_id,"ACTUALIZAR","consultas",this.consultaSeleccionada.id,"Se actualiza el estatus de la consulta con id: "+this.consultaSeleccionada.id+" a: "+this.formEstatus.estatus_cita);

                        this.mostrarDialogoEstatus = false;
                        this.citasPorFecha(moment(this.fechaSeleccionada.date).format('YYYY-MM-DD')); // Actualiza las consultas
                    } else {
                        this.notify('error', response.data.message || 'Error al actualizar el estatus.');
                    }
                } catch (error) {
                    console.error('Error al actualizar el estatus:', error.response?.data?.message || error.message);
                    this.notify('error', error.response?.data?.message || error.message);
                }
            },
            eliminarEventsWrapper() {
                const eventsWrapper = document.querySelector('.events-wrapper');
                if (eventsWrapper) {
                    eventsWrapper.remove();
                    console.log('Elemento .events-wrapper eliminado');
                }

                const calWrapper = document.querySelector('.cal-wrapper');
                if (calWrapper) {
                    calWrapper.style.setProperty('width', '100%', 'important'); // Cambia la propiedad width a 100% !important
                    console.log('Propiedad width de .cal-wrapper establecida en 100% !important');
                }
            },
            async cargarHorariosDisponibles() {
                try {
                    const response = await axios.get(`${API}/listar_horarios`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    const data = response.data; // Use the response from axios
                    if (data.status === 'success') {
                        this.horariosDisponibles = data.data; // Almacena los horarios en la variable
                        console.log('Horarios disponibles:', this.horariosDisponibles);
                    } else {
                        console.error('Error al cargar horarios:', data.message);
                    }
                } catch (error) {
                    console.error('Error al consumir el endpoint:', error);
                }
            },
            async cargarEventos() {
                try {
                    const response = await axios.get(`${API}/listar-consultas-agendadas`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    const data = response.data;

                    if (data.status === 'success') {
                        this.eventos = data.data.map(evento => {
                            if (!evento.inicio_cita || !evento.fin_cita) {
                                console.error('Evento inválido:', evento);
                                return null;
                            }
                            return {
                                date: moment(evento.inicio_cita).format('YYYY/M/D'), // Formatea la fecha con moment
                                title: evento.motivo,
                                horaInicio: evento.inicio_cita.split('T')[1]?.slice(0, 5), // Extrae la hora de inicio
                                horaFin: evento.fin_cita.split('T')[1]?.slice(0, 5) // Extrae la hora de fin
                            };
                        }).filter(evento => evento !== null); // Filtra eventos inválidos

                        // Forzar reactividad del calendario
                        this.eventos = [...this.eventos];
                        console.log('Eventos cargados y marcados en el calendario:', this.eventos);
                    } else {
                        console.error('Error al cargar eventos:', data.message);
                    }
                } catch (error) {
                    console.error('Error al consumir el endpoint de eventos:', error);
                }
            },
            async cargarConsultasHoy() {
                try {
                    const response = await axios.get(`${API}/listar-consultas-hoy`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    const data = response.data;

                    if (data.status === 'success') {
                        this.consultasHoy = data.data
                        console.log('Consultas de hoy cargadas:', this.consultasHoy);
                    } else {
                        console.error('Error al cargar consultas de hoy:', data.message);
                    }
                } catch (error) {
                    console.error('Error al consumir el endpoint de consultas de hoy:', error);
                }
            },
            formatFecha(fecha) {
                const opciones = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return new Date(fecha).toLocaleDateString('es-ES', opciones);
            },
            formatFechaHora(fecha, hora) {
                const opcionesFecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
                const fechaFormateada = new Date(fecha).toLocaleDateString('es-ES', opcionesFecha);
                return `${fechaFormateada} a las ${hora}`;
            },
            formatTime(time) {
                if (!time) return '';
                const [hour, minute] = time.split(':');
                const hourInt = parseInt(hour, 10);
                const period = hourInt >= 12 ? 'PM' : 'AM';
                const formattedHour = hourInt % 12 || 12; // Convert 0 to 12 for 12-hour format
                return `${formattedHour}:${minute} ${period}`;
            }
        }
    };
</script>

<style scoped>

    .cal-wrapper {
        margin-top: 0 !important;
        /* Elimina cualquier margen superior */
        padding-top: 0 !important;
        /* Elimina cualquier padding superior */
        display: flex;
        align-items: flex-start;
        /* Alinea el contenido al inicio */
    }

    .form-label {
        font-weight: bold;
    }

    .form-control {
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 8px;
    }

    .list-group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .__vev_calendar-wrapper .cal-wrapper .cal-header {
        background-color: red !important;
    }
</style>